
const vergelijken = {

	init() {

		var stap = $('#container-vergelijking').attr('stap');

		// Definieer url variabele op basis van de locatie van browservenster
		var url = window.location.href;
		// Voeg forward slash toe als deze er niet is
		if (url.charAt(url.length - 1) != '/') {
			url = url + '/';
		}

		// Javascript voor stap 2
		if (stap == 2) {

			$('.btn-print').click(function(e) {
				e.preventDefault();
				window.print();
			});

			// Click functie voor checkbox in dropdown menu
			$('#maatschappijSelect input[type=checkbox]').click(function() {
				// Simuleer click op bovenliggend anchor element
				$(this).parent().trigger('click');
			});

			// Click functie voor anchor in dropdown menu
			$('#maatschappijSelect a').click(function() {
				// Trigger click op input checkbox
				$(this).find('input').trigger('click');
			});

			// Voorkom dropdown standaard functie
			$('.dropdown-menu').click(function(e) {
				e.stopPropagation();
			});

			// Functie op maarschappij kolommen te tonen en verbergen
			$('#maatschappijSelect input').change(function(e) {

				// Voorkom standaard functie van inputs
				e.preventDefault;

				// Check of huidige input al gecheckt is en check deze als dat zo is
				$(this).find('input').prop('checked', !$(this).find('input').prop('checked'));

				// Maak nieuwe array aan voor maatschappijen
				var maatschappijen = new Array();

				// Voeg item aan array toe voor elke checkbox
				$(this).closest('div').find('input:checked').each(function() {
					maatschappijen.push($(this).data('mij'));
				});

				// Verberg alle kolommen
				$('.table-voorwaarden-vergelijker tbody tr td').addClass('d-none');
				$('.table-voorwaarden-vergelijker thead tr th.aanbieder').addClass('d-none');

				// Als er geen aanbieders geselecteerd zijn toon dan een lege kolom
				if (maatschappijen.length == 0) {
					$('.table-voorwaarden-vergelijker tbody tr.row-property td:last-child').removeClass('d-none');
					$('.table-voorwaarden-vergelijker thead tr th:last-child').removeClass('d-none');
				} else {
					$('.table-voorwaarden-vergelijker thead tr th:last-child').addClass('d-none');
				}

				// Voor elke aanbieder toon de kolom en trigger de select zodat de kolom wordt gevuld
				$.each(maatschappijen, function(key, value) {
					$('.table-voorwaarden-vergelijker').find('thead,tbody').find('.aanbieder_' + value).removeClass('d-none');
					$('.table-voorwaarden-vergelijker').find('thead,tbody').find('.aanbieder_' + value).find('select').trigger('change');
				});

				// Werk de colspan van de titels bij a.h.v. het aantal geselecteerde aanbieders
				var l = $('#maatschappijSelect ul.dropdown-menu input:checked').length;
				var s = $('.table-voorwaarden-vergelijker tbody tr:nth-child(2) td:visible').length + 1;
				if (l != 0) {
					$('.row-title th').hide(0).attr('colspan', s).show(0);
				} else {
					$('.row-title th').hide(0).attr('colspan', 100).show(0);
				}

				// Voorkom standaard gedrag van input
				return false;

			});

			// Functie die de kolom vult a.h.v. de gekozen
			$('.voorwaarde-selector').change(function() {

				// Haal aanbieder id uit aanbieder data attibuut
				var aanbieder = $(this).data('aanbieder');

				// Haal voorwaarde id uit aanbieder data attibuut
				var voorwaarde_id = $(this).val();

				// Als de id niet leeg is
				if (voorwaarde_id != '' && voorwaarde_id != null) {

					// Definieer url met daarin de kokozen waarden
					var actionArray = [url + aanbieder, voorwaarde_id, ''];

					// Ajax functie
					$.ajax({
						type: 'GET',
						url: actionArray.join('/'),
						success: function(data) {
							// Wanneer de waarde die teruggegeven wordt niet leeg is
							if (data.length != 0) {

								// Voor elk item in het dataobject
								$.each(data, function(group_key, value) {
									// Voor elke voorwaarde in item in het
									$.each(value, function(key, item) {
										// Vervang u20ac voor euro teken
										item = item.replace(/u20ac/g, '€');
										// Vul de cellen met de juste waarde
										$('.aanbieder_' + aanbieder + '.vraag_' + group_key + '-' + key).html(vergelijken.linkify(item));
									});
								});

							}
						}
					});
				}

			});
		}

	},

	linkify: function(inputText) {
		var replacedText, replacePattern1, replacePattern2;
		//URLs starting with http://, https://, or ftp://
		replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
		replacedText = inputText.replace(replacePattern1, '<u><a href="$1" target="_blank">Bekijken</a></u>');
		//URLs starting with "www." (without // before it, or it'd re-link the ones done above).
		replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
		replacedText = replacedText.replace(replacePattern2, '$1<u><a href="http://$2" target="_blank">Bekijken</a></u>');
		return replacedText;
	}

};

export default vergelijken;
